<template>
  <el-dialog
      v-loading="loading"
      title="新增客企"
      :visible.sync="visible"
      append-to-body
      destroy-on-close
      width="500px"
      :before-close="handleClose">
    <el-form :model="form" ref="form" label-width="110px" :rules="rules" class="demo-dynamic">
      <el-form-item label="部门名称" prop="deptName">
        <el-input v-model="form.deptName"></el-input>
      </el-form-item>
      <el-form-item label="组织机构代码" prop="organizeCode">
        <el-input v-model="form.organizeCode"></el-input>
      </el-form-item>
      <el-form-item label="部门联系电话" prop="telephone">
        <el-input v-model="form.telephone"></el-input>
      </el-form-item>
      <el-form-item label="法人名称" prop="legalPersonName">
        <el-input v-model="form.legalPersonName"></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="phone">
        <el-input v-model="form.phone"></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="password">
        <el-input v-model="form.password" show-password></el-input>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script lang="ts">
export default {
  name: "create",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
  },
  data() {
    var validPhone = (rule, value, callback) => {
      let reg = /^1[3456789]\d{9}$/;
      if (value === "") {
        callback(new Error("请输入实名手机号码"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入实名手机号码"));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      form: {},
      rules: {
        deptName: [{required: true, message: "请输入部门名称", trigger: "blur"}],
        organizeCode: [{required: true, message: "请输入组织机构代码", trigger: "blur"}],
        legalPersonName: [{required: true, message: "请输入法人名称", trigger: "blur"}],
        phone: [{required: true, validator: validPhone, trigger: "blur"}],
        telephone: [{required: true, validator: validPhone, trigger: "blur"}],
        password: [{required: true, message: "请输入密码", trigger: "blur"}],
      },
    }
  },
  methods: {
    handleConfirm() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.loading = true;
          let params = JSON.parse(JSON.stringify(this.form))
          params.deptName = params.deptName + '|' + params.telephone
          this.$http.post(this.$api.customerEnterprise.addChildDept, params).then((res) => {
            if (res.data.code == 200) {
              this.$emit('handleQuery')
              this.$message.success(res.data.msg);
              this.handleClose()
              this.loading = false
            } else {
              this.$message.error(res.data.msg)
              this.loading = false
            }
          })
        }
      })
    },
    // 关闭抽屉
    handleClose() {
      this.updateDialog(false)
    },
    /* 更新visible */
    updateDialog(value) {
      this.$emit('update:visible', value);
    }
  }
}
</script>

<style scoped lang="less">

</style>
